module.exports = __webpack_public_path__ + "static/img/2.baa1a4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R417A/2.jpg
// module id = Lzg1
// module chunks = 1